module.exports = __webpack_public_path__ + "img/group-13.a1501dae.png";